if (typeof FacetFiltersForm === 'undefined') {
  // Override jQuery.ajax to add locale to all AJAX requests
  if (window.jQuery) {
    const originalAjax = window.jQuery.ajax;
    window.jQuery.ajax = function(settings) {
      // Detect locale from pathname
      let locale = '';
      const localeMatch = window.location.pathname.match(/^\/(fr|es|de|it|pt|ja|ko|zh|nl|pl|ru|sv|da|no|fi)(?:\/|$)/);
      if (localeMatch) {
        locale = localeMatch[1];
      }
      
      // Add locale to URL if not already there
      if (locale && settings.url) {
        if (!settings.url.includes('/fr/') && !settings.url.includes('/es/') && !settings.url.includes('/de/')) {
          // Insert locale into the URL path
          settings.url = settings.url.replace(/^\//, `/${locale}/`);
          console.log('🌐 jQuery.ajax override - Added locale to URL:', settings.url);
        }
      }
      
      return originalAjax.call(this, settings);
    };
    console.log('✅ Overridden jQuery.ajax to add locale to all AJAX requests');
  }

  // Prevent script execution from AJAX responses that change locale
  (function() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // Remove only localization-related scripts
          mutation.addedNodes.forEach((node) => {
            if (node.tagName === 'SCRIPT') {
              const src = node.getAttribute('src') || '';
              const content = node.textContent || '';
              if (src.includes('localization') || content.includes('localization')) {
                node.remove();
                console.log('⛔ Removed localization script');
              }
            } else if (node.nodeType === 1) { // Element node
              node.querySelectorAll('script').forEach(script => {
                const src = script.getAttribute('src') || '';
                const content = script.textContent || '';
                if (src.includes('localization') || content.includes('localization')) {
                  script.remove();
                  console.log('⛔ Removed localization script');
                }
              });
            }
          });
        }
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();

  class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 800);

      const facetForm = this.querySelector('form');
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

      const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
      if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      // Detect locale from pathname
      let pathname = window.location.pathname;
      let locale = '';
      const localeMatch = pathname.match(/^\/(fr|es|de|it|pt|ja|ko|zh|nl|pl|ru|sv|da|no|fi)(?:\/|$)/);
      if (localeMatch) {
        locale = localeMatch[1];
      }
      
      console.log('🌍 detectLocale - pathname:', pathname, 'locale:', locale); // DEBUG
      
      // Build URL with explicit locale parameter for server
      let url = `${pathname}?section_id=${section.section}&${searchParams}`;
      if (locale) {
        url += `&locale=${locale}`;
      }
      
      console.log('🔗 buildURL - final URL:', url); // DEBUG
      
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    console.log('🔍 AJAX Fetch URL:', url); // DEBUG
    console.log('📍 Current pathname:', window.location.pathname); // DEBUG
    console.log('🌐 URL includes /fr/:', url.includes('/fr/')); // DEBUG
    
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        // Remove localization-related script tags from response
        let html = responseText
          .replace(/<script[^>]*localization[^>]*>[\s\S]*?<\/script>/gi, '')
          .replace(/<script[^>]*src="[^"]*localization[^"]*"[^>]*>[\s\S]*?<\/script>/gi, '');
        
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        // DISABLED: This may be interfering with locale content
        // if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    // DISABLED: This may be interfering with locale content
    // if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    // Detect locale from pathname
    let locale = '';
    const localeMatch = window.location.pathname.match(/^\/(fr|es|de|it|pt|ja|ko|zh|nl|pl|ru|sv|da|no|fi)(?:\/|$)/);
    if (localeMatch) {
      locale = localeMatch[1];
    }

    // Parse and render HTML
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    let containerHTML = parsedHTML.getElementById('ProductGridContainer').innerHTML;

    // If we have a locale, fix product links to include locale prefix
    if (locale) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = containerHTML;
      
      // Fix all product links to include locale prefix
      tempDiv.querySelectorAll('a[href*="/products/"]').forEach(link => {
        const href = link.getAttribute('href');
        // Only add prefix if it doesn't already have one
        if (!href.match(/^\/(fr|es|de|it|pt|ja|ko|zh|nl|pl|ru|sv|da|no|fi)\//)) {
          link.setAttribute('href', `/${locale}${href}`);
        }
      });
      
      containerHTML = tempDiv.innerHTML;
    }

    document.getElementById('ProductGridContainer').innerHTML = containerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    // Re-initialize custom filter buttons if they exist
    FacetFiltersForm.reinitializeCustomFilters();
  }

  static reinitializeCustomFilters() {
    // Find section container and reinitialize custom filter buttons
    const sections = document.querySelectorAll('[id^="collection-"]');
    sections.forEach(section => {
      const filterButtons = section.querySelectorAll('.filter_title');
      const products = section.querySelectorAll('li[data-rel]');

      if (filterButtons.length === 0 || products.length === 0) return;

      // Re-add click listeners to custom filter buttons
      filterButtons.forEach(button => {
        // Remove existing listeners by cloning
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        newButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          const selectedTag = this.getAttribute('data-tag');
          const selectedTitle = this.getAttribute('data-title');

          // Update active state
          section.querySelectorAll('.filter_title').forEach(btn => btn.classList.remove('active'));
          this.classList.add('active');

          // Filter products
          section.querySelectorAll('li[data-rel]').forEach(product => {
            const productTags = product.getAttribute('data-rel').trim().split(/\s+/);
            if (selectedTag === 'all' || productTags.includes(selectedTag)) {
              product.style.display = '';
            } else {
              product.style.display = 'none';
            }
          });
        });
      });
    });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    console.log('🔄 renderFilters called'); // DEBUG
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    console.log('📊 Facets found in response:', facetDetailsElementsFromFetch.length); // DEBUG
    
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    console.log('📊 Facets in DOM before update:', facetDetailsElementsFromDom.length); // DEBUG

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    try {
      FacetFiltersForm.renderAdditionalElements(parsedHTML);
    } catch (e) {
      console.warn('Error in renderAdditionalElements:', e);
    }

    if (countsToRender && event) {
      try {
        const closestJSFilterID = event.target.closest('.js-filter').id;

        if (closestJSFilterID) {
          FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
          FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

          const newFacetDetailsElement = document.getElementById(closestJSFilterID);
          const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

          const isTextInput = event.target.getAttribute('type') === 'text';

          if (newElementToActivate && !isTextInput) newElementToActivate.focus();
        }
      } catch (e) {
        console.warn('Error updating counts:', e);
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      try {
        document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      } catch (e) {
        console.warn('Error updating selector:', selector, e);
      }
    });

    try {
      const menuDrawer = document.getElementById('FacetFiltersFormMobile').closest('menu-drawer');
      if (menuDrawer && menuDrawer.bindEvents) {
        menuDrawer.bindEvents();
      }
    } catch (e) {
      console.warn('Error binding menu drawer events:', e);
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define('facet-filters-form', FacetFiltersForm);
  FacetFiltersForm.setListeners();

  class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

  customElements.define('price-range', PriceRange);

  class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

  customElements.define('facet-remove', FacetRemove);
}
